import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faClock } from '@fortawesome/pro-regular-svg-icons';

// manor
import { Typography } from '@comparethemarketau/manor-typography';
import { Link } from '@comparethemarketau/manor-link';

import { formatOpeningHours } from '../common/opening_hours_formatter';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginTop: theme.spacing[24],
        marginBottom: theme.spacing[24]
    },
    contactUsTitle: {
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.grey900,
        fontSize: theme.fontSize.xl
    },
    callUsNowContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing[12]
    },
    callUsNowText: {
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey900,
        fontSize: theme.fontSize.base
    },
    phoneIcon: {
        color: theme.colors.primary500,
        marginLeft: '1rem',
        marginRight: '1rem',
        fontSize: theme.fontSize.base
    },
    phoneNumber: {
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.primary500,
        fontSize: theme.fontSize.base
    },
    openingHoursTitleContainer: {
        display: 'flex',
        marginTop: theme.spacing[12],
        alignItems: 'center'
    },
    openingHoursText: {
        paddingLeft: '1rem',
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.grey900,
        fontSize: theme.fontSize.base
    },
    openingHoursListContainer: {
        paddingLeft: theme.spacing[20]
    }
}));

const CallDirectInformation = (props) => {
    const { phoneNumber, callCentreHours } = props;
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const hoursArray = formatOpeningHours(callCentreHours);

    return (
        <div className={classes.container}>
            <div>
                <Typography className={classes.contactUsTitle}>Contact us</Typography>
                <div className={classes.callUsNowContainer}>
                    <Typography className={classes.callUsNowText}>Call us now</Typography>
                    <FontAwesomeIcon className={classes.phoneIcon} icon={faPhoneAlt} />
                    <Typography className={classes.phoneNumber}>
                        <Link trackingLabel="Link for provider phone" underline="none" href={`tel:${phoneNumber}`}>{phoneNumber}</Link>
                    </Typography>
                </div>
            </div>
            <div>
                <div className={classes.openingHoursTitleContainer}>
                    <FontAwesomeIcon icon={faClock} size="sm" />
                    <Typography className={classes.openingHoursText}>{'Our opening hours'}</Typography>
                </div>
                <div className={classes.openingHoursListContainer}>
                    {hoursArray.map((hoursPolicy) => <Typography key={hoursPolicy}>{hoursPolicy}</Typography>)}
                </div>
            </div>
        </div>
    );
};

CallDirectInformation.propTypes = {
    phoneNumber: PropTypes.string,
    callCentreHours: PropTypes.string
};

export { CallDirectInformation };
